import { render } from "./VetReviewPost.vue?vue&type=template&id=75a3ba25&scoped=true&ts=true"
import script from "./VetReviewPost.vue?vue&type=script&lang=ts"
export * from "./VetReviewPost.vue?vue&type=script&lang=ts"

import "./VetReviewPost.vue?vue&type=style&index=0&id=75a3ba25&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75a3ba25"]])

export default __exports__